import React, { forwardRef } from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    margin: "0px auto",
    paddingLeft: "16px",
    paddingRight: "16px",
    ['@media (min-width: 576px)']: {
      maxWidth: "540px"
    },
    ['@media (min-width: 768px)']: {
      maxWidth: "720px"
    },
    ['@media (min-width: 992px)']: {
      maxWidth: "960px"
    },
    ['@media (min-width: 1200px)']: {
      maxWidth: "1140px"
    },
  }
}));

/**
 * Bootstrap-like container with variable max width depends on window width
 * @name Container
 * @param {object} props React component properties
 * @param {string} [props.className] CSS-class of container
 * @param {func} [props.ref] Ref
 * @example
 * return (
 *  <Container className = { "container-class" } >
 *    <React.Fragment>
 *      { "SOME CONTENT" }
 *    </React.Fragment>
 *  </Container>
 * )
*/

const Container = forwardRef((props, ref) => {
  const classes = blockStyles();
  const { className, children } = props;

  return (
    <div className = { clsx(classes.root, className) }
         ref = { ref } >
      { children }
    </div>
  );
});

export default Container;